// extracted by mini-css-extract-plugin
export default {"root":"homeUser_root__KYKw6","user_root":"homeUser_user_root__dV2Gi","iconBox":"homeUser_iconBox__VhlJv","name":"homeUser_name__BVGj0"};